/**
 * Utility functions for displaying usage limits
 * Handles unlimited tiers by showing ∞ instead of -1 or 999999
 */

/**
 * Check if a limit represents unlimited usage
 * Note: null/undefined means loading, not unlimited
 */
export const isUnlimited = (limit: number | null | undefined): boolean => {
  return limit === -1 || limit === 999999;
};

/**
 * Check if usage data is still loading
 */
export const isLoadingUsage = (limit: number | null | undefined): boolean => {
  return limit === null || limit === undefined;
};

/**
 * Format a limit value for display
 * Returns ∞ for unlimited, -- for loading, or the number as string
 */
export const formatLimit = (limit: number | null | undefined): string => {
  if (isLoadingUsage(limit)) {
    return '--';
  }
  if (isUnlimited(limit)) {
    return '∞';
  }
  return String(limit);
};

/**
 * Format remaining count for display
 * Returns "Unlimited" for -1/999999, "Loading..." for null, or the number
 */
export const formatRemaining = (remaining: number | null | undefined): string => {
  if (remaining === null || remaining === undefined) {
    return 'Loading...';
  }
  if (remaining === -1 || remaining === 999999) {
    return 'Unlimited';
  }
  return String(remaining);
};

/**
 * Format usage display (e.g., "5 / 10" or "5 / ∞")
 */
export const formatUsageDisplay = (count: number, limit: number | null | undefined): string => {
  return `${count} / ${formatLimit(limit)}`;
};
